<div class="checkout-page">

  <div class="checkout-container">

    <div class="pix-card">

      <h1>Pague com PIX</h1>

      <p class="instrucao">
        Escaneie o QR Code ou copie o código abaixo
        para realizar o pagamento.
      </p>

      <div
        class="carregando"
        *ngIf="carregando"
      >
        <div class="loading-spinner"></div>

        <span>
          Gerando seu PIX...
        </span>
      </div>

      <div
        class="pix-conteudo"
        *ngIf="!carregando && pagamento"
      >

        <div class="qr-area">

          <div class="qr-container">

            <img
              [src]="qrCode"
              alt="QR Code para pagamento PIX"
              class="qr-code"
              *ngIf="qrCode"
            >

            <div
              class="qr-erro"
              *ngIf="!qrCode"
            >
              QR Code indisponível.
            </div>

          </div>

          <p class="qr-ajuda">
            Abra o aplicativo do seu banco
            e escaneie o QR Code.
          </p>

        </div>


        <div class="pix-copia-cola">

          <label>
            PIX Copia e Cola
          </label>

          <div class="codigo-container">

            <textarea
              readonly
              [value]="codigoPix"
              rows="4"
            ></textarea>

            <button
              type="button"
              class="btn-copiar"
              (click)="copiarPix()"
              [disabled]="!codigoPix"
            >
              Copiar código
            </button>

          </div>

        </div>


        <div
          class="pix-expiracao"
          *ngIf="expiraEm"
        >

          <strong>
            PIX válido até:
          </strong>

          <span>
            {{ formatarExpiracao(expiraEm) }}
          </span>

        </div>

        <div
          class="pix-status"
          *ngIf="pagamento.status"
        >

          <strong>
            Status:
          </strong>

          <span>
            {{ pagamento.status }}
          </span>

        </div>

        <div class="aviso">

          <strong>
            Antes de efetuar o pagamento,
            leia atentamente os avisos:
          </strong>

          <p>
            Não aceitamos pagamentos de terceiros,
            ou seja, o valor depositado deve vir de
            uma conta com o seu CPF/CNPJ.
          </p>

          <p>
            O valor do depósito não pode ultrapassar
            o seu limite disponível.
          </p>

        </div>

        <div class="actions">

          <button
            type="button"
            class="btn-confirmar"
            (click)="confirmarPagamento()"
          >
            Já fiz o pagamento
          </button>

        </div>

      </div>

      <div
        class="pagamento-erro"
        *ngIf="!carregando && !pagamento"
      >

        <p>
          Não foi possível carregar os dados do PIX.
        </p>

        <button
          type="button"
          class="btn-voltar"
          (click)="voltar()"
        >
          Voltar
        </button>

      </div>

    </div>


    <div class="resumo-card">

      <div class="resumo-topo">

        <img
          [src]="
            dados?.quartoImagem
          "
          alt="Cabana"
        >

        <div>

          <h3>
            {{
              dados?.quartoNome
            }}
          </h3>

          <p>
            {{ descricaoAcomodacao }}
          </p>

        </div>

      </div>

      <div class="resumo-linha">

        <strong>
          Datas
        </strong>

        <span>
          {{ formatarData(dados?.checkIn) }}
          -
          {{ formatarData(dados?.checkOut) }}
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Hóspedes
        </strong>

        <span>
          {{ dados?.adultos || 0 }}
          adulto(s),

          {{ dados?.criancas || 0 }}
          criança(s)

          e

          {{ dados?.animais || 0 }}
          animal(is)
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Noites
        </strong>

        <span>
          {{ dados?.quantidadeNoites || 0 }}
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Diária
        </strong>

        <span>
          R$
          {{
            (dados?.valorDiaria || 0)
              | number:'1.2-2'
          }}
        </span>

      </div>

      <div class="resumo-linha total">

        <strong>
          Preço total
        </strong>

        <span class="valor">
          R$
          {{
            valorTotal
              | number:'1.2-2'
          }}
        </span>

      </div>

    </div>

  </div>

</div>
